<template>
  <div class="queryDesc legend-wrap">
    <div class="legend">
      <!-- 图例 -->
      <span style="font-weight: bold;">{{ t('图例') }}:</span>
      <p v-for="(item) in legendsList" :key="item.label">
        <span>{{ item.label }}:&nbsp;</span>
        <button
          :class="item.className"
          v-for="(item) in item.btns"
          :key="`btn-${item.btnText}`"
        >
          {{ item.btnText }}
        </button>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OmsLegend',
  props: {
    legends: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      legendsList: []
    }
  },
  created() {
    this.legendsList = this.legends.length 
      ? this.legends 
      : [
          {
            label: t('提交状态'), // 提交状态
            btns: [
              { className: 'color-blue', btnText: t('已发布') } // 已发布
            ]
          },
          {
            label: t('草稿状态'), // 草稿状态
            btns: [
              { className: 'color-italic-black', btnText: t('草稿') } // 草稿
              ]
            },
          {
            label: t('下线/过期状态'), // 下线/过期状态
            btns: [
              { className: 'color-italic-grey', btnText: t('下线') }, // 下线
              { className: 'color-italic-grey', btnText: t('过期') }, // 过期
            ] 
          }
        ]
  }
};
</script>
<style lang="less" scoped>
  .queryDesc.legend-wrap {
    height: 40px;
    line-height: 40px;
    margin: 0; // 避免动态渲染ag高度时10px误差
  }
</style>